<!-- eslint-disable @angular-eslint/template/no-call-expression -->

<div class="slice-marquee-wrapper">
  <swiper
    *ngIf="slidesRange.length > 0"
    [config]="config">

    <ng-container *ngIf="slidesRange.length === 1; else multipleSlides">
      <ng-template
      *ngFor="let slide of singleSlide; trackBy: trackByIndex"
      swiperSlide
      >
        <render-slice-slot
          data-e2e="render-slice-slot"
          [slice]="slice"
          [slot]="(slide + 1).toString()"
          [ngStyle]="getSlotStyles(slots[slide])">
        </render-slice-slot>
      </ng-template>
    </ng-container>

    <ng-template #multipleSlides>
      <ng-template
        *ngFor="let slide of slidesRange; trackBy: trackByIndex"
        swiperSlide
      >
        <render-slice-slot
          data-e2e="render-slice-slot"
          [slice]="slice"
          [slot]="(slide + 1).toString()"
          [ngStyle]="getSlotStyles(slots[slide])">
        </render-slice-slot>
      </ng-template>
    </ng-template>
  </swiper>
</div>


